import type { RecentVisitItem } from '@gat-ship/types'

/**
 * Whether a search term matches an existing saved-search bookmark. An empty or
 * missing term is never considered bookmarked.
 */
export function isSearchBookmarked(
  bookmarks: readonly { searchTerm?: string }[],
  searchTerm: string | undefined
): boolean {
  if (!searchTerm) {
    return false
  }
  return bookmarks.some((bookmark) => bookmark.searchTerm === searchTerm)
}

/**
 * Prepend a freshly visited item to the recently-visited list, de-duplicating
 * by id and capping the result at `max` entries. Never mutates `existing`.
 */
export function dedupeRecentVisits(
  existing: readonly RecentVisitItem[],
  next: RecentVisitItem,
  max: number
): RecentVisitItem[] {
  return [next, ...existing.filter((item) => item.id !== next.id)].slice(0, max)
}
